import React, { useMemo } from "react";
import ReactQuill from "react-quill";

interface EmailRichEditorProps {
  html: string;
  onChange: (html: string) => void;
  placeholder?: string;
}

export const EmailRichEditor: React.FC<EmailRichEditorProps> = ({
  html,
  onChange,
  placeholder,
}) => {
  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote", "link"],
        ["clean"],
      ],
    }),
    []
  );

  const formats = [
    "header",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "align",
    "list",
    "bullet",
    "blockquote",
    "link",
  ];

  return (
    <div className="email-mkt__rich-editor">
      <ReactQuill
        theme="snow"
        value={html}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
      />
    </div>
  );
};
